export default "__VITE_ASSET__D$dvlY4K__"